export default __webpack_public_path__ + "static/media/8.078d289b.png";